import React, { useState } from "react";
import { X } from "lucide-react";
import Image from "next/image";
import MilesIcon from "@/public/events/miles_icon.png";
import useMilesOneDeepLink from "@/hooks/useMilesOneDeepLink";

const AppDownloadStrip = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { tryOpenApp } = useMilesOneDeepLink();

  // const handleOpenPlaystore = async () => {
  //   try {
  //     const res = await fetch(
  //       "https://webhook.miles-api.com/webhook/open-playstore"
  //     );
  //     const data = await res.json();

  //     if (data?.url) {
  //       window.location.href = data.url;
  //     } else {
  //       console.warn("Playstore URL not found in response.");
  //     }
  //   } catch (error) {
  //     console.error("Error triggering webhook:", error);
  //   }
  // };

  // Handle click by preventing the default navigation and then triggering deep linking logic.

  // const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault();
  //   // console.log("Download strip clicked");
  //   tryOpenApp();
  // };

  if (!isVisible) return null;

  // When the user clicks the link, run the deep linking logic.
  // const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault(); // prevent default navigation
  //   // console.log("Download strip clicked");
  //   tryOpenApp();
  // };

  return (
    <div className="relative w-full h-[42px] bg-gray-700 flex items-center px-4">
      {/* Centered Icon + Text (Clickable) */}
      <div
        // href="#"
        // onClick={handleClick}
        className="w-full flex justify-center pr-[48px] ml-[6px] cursor-pointer"
        onClick={() => {
          tryOpenApp();
        }}
      >
        <div className="flex items-center ml-7">
          <div className="w-[26px] h-[26px] rounded-[4px] flex items-center justify-center overflow-hidden">
            <Image
              src={MilesIcon}
              alt="Miles Icon"
              width={22}
              height={22}
              style={{ objectFit: "contain" }}
            />
          </div>
          <p
            className="ml-[4px] text-white text-[14px] font-medium leading-[16px] tracking-[-0.02em] text-center"
            style={{
              fontFamily: "Work Sans",
              width: "227px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Download the{" "}
            <span
              style={{
                color: "#3399FF",
                padding: "0 4px",
                borderRadius: "2px",
              }}
            >
              Miles One
            </span>{" "}
            app now!
          </p>
        </div>
      </div>

      {/* Close Icon */}
      <button
        className="absolute right-1 top-1/2 -translate-y-1/2 p-1"
        onClick={() => setIsVisible(false)}
      >
        <X size={20} color="white" />
      </button>
    </div>
  );
};

export default AppDownloadStrip;
